import { Component, OnInit } from '@angular/core';
import { ColumnHeader } from 'src/app/models/column-header';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/services/common-service/common.service';
import { ToastrService } from 'ngx-toastr';
import { Labels } from'src/app/constants/labels';
import { RoutePath } from'src/app/constants/routerPath';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmModalComponent } from 'src/app/components/modal/confirm-modal/confirm-modal.component';
import { SrcPath } from'src/app/constants/srcPath';
import { KEYS } from'src/app/constants/keys';
import { isData, isPresent } from 'src/app/utils/utils';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-modules',
  templateUrl: './modules.component.html',
  styleUrls: ['./modules.component.scss'],
  imports:[CommonModule,SharedModule]
})
export class ModulesComponent implements OnInit {

  headerData: ColumnHeader | any;
  menuListdata: any;
  menuParentListdata: any;
  menuChildListdata: any = [];
  menuParentId: any = '0';
  previousParentId: any = '0';
  customerId: string | any;
  labelMessages = Labels.messages;
  labelButton = Labels.buttons;
  bsModalRef!: BsModalRef;
  srcPath = SrcPath;
  isSuperaDmin: boolean = false;
  dbPath: any = '';
  menumoduleorderData: any = [];
  adminMenuIcon = SrcPath.adminMenuIcon;
  messageLabel = Labels.messages;

  constructor(private router: Router, private commonService: CommonService, private toastr: ToastrService, private modalService: BsModalService) { }

  ngOnInit(): void {
    this.loadOrderMenuData(0);
    this.isSuperAdmin();
    this.initColumnHeader('Modules', true, this.labelButton.addModule, false, '', '', '');
    this.customerId = (this.commonService.getUserCredentials(KEYS.credential_customer_id));
    this.LoadMenu();
  }
  isSuperAdmin() {
    const sessionSuperAdmin = sessionStorage.getItem(KEYS.isSuperAdmin);
    if (sessionSuperAdmin)
      this.isSuperaDmin = JSON.parse(sessionSuperAdmin);
    if (this.isSuperaDmin) {
      const sessionCustomerPath = sessionStorage.getItem(KEYS.customerDbPath);
      if (sessionCustomerPath)
        this.dbPath = JSON.parse(sessionCustomerPath);
    }
  }
  private initColumnHeader(title: string, btnShow: boolean, name: string, topbtnShow: boolean, prptitle: string, prpicon: string, prpclass: string) {
    this.headerData = {
      title: title,
      button: {
        show: btnShow,
        name: name
      },
      topButton: {
        show: topbtnShow,
        property: [
          {
            title: prptitle,
            icon: prpicon,
            class: prpclass
          }
        ]
      }
    };
  }

  LoadMenu() {
    this.menuListdata = [];
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.commonService.loadMenuforAdmin(dbFullPath, this.customerId).subscribe((data: any) => {
      if (isData(data)) {
        this.menuListdata = data['table'];
        this.menuChildListdata = data['table'].filter((x: any) => x.gstibo_parent_menu_id == this.menuParentId);

        this.commonService.ogLog("menuListdata", this.menuListdata);
        this.commonService.ogLog("menuChildListdata", this.menuChildListdata);

        this.loadStatcmenus();
      } else {
        this.commonService.ogLog('data not available');
      }
    },
      error => {
        console.log('executeLogicAppsApi Error:', error);
      });

  }

  viewChild(parentId: any) {
    this.previousParentId = this.menuParentId;
    this.commonService.ogLog('parentId : ', parentId);
    this.menuParentId = parentId;
    this.menuChildListdata = this.menuListdata.filter((x: any) => x.gstibo_parent_menu_id == parentId);
    // this.menuChildListdata.forEach(element=>{
    //   this.menuChildListdata.push({
    //     'moduleorderId':element.gstibo_listing_order,
    //   })
    // })
    this.commonService.ogLog('this.menuChildListdata : ', this.menuChildListdata);
    this.initColumnHeader(Labels.menu.title, false, '', true, Labels.menu.prptitle, SrcPath.previousIcon, Labels.menu.class);
  }

  editMenu(menu_id: any) {
    let menuDetails = this.menuListdata.filter((data: any) => data.gstibo_menu_id == menu_id);
    if (!isPresent(menuDetails)) {
      menuDetails = this.menuChildListdata.filter((g: any) => g.gstibo_menu_id == menu_id);
      if (isPresent(this.menumoduleorderData)) {
        let dataF = this.menumoduleorderData.filter((g: any) => g.gstibo_menu_id == menu_id)[0];
        let moduleorderId = this.menumoduleorderData.filter((g: any) => g.gstibo_menu_id == menu_id)[0]['gstibo_menu_listing_order'];
        menuDetails.push({
          'moduleorderId': moduleorderId
        })
      }

    }
    else {
      if (isPresent(this.menumoduleorderData)) {
        let moduleorderId = this.menumoduleorderData.filter((g: any) => g.gstibo_menu_id == menu_id)[0]['gstibo_menu_listing_order'];
        menuDetails.push({
          'moduleorderId': moduleorderId
        });
      }
    }
    this.commonService.ogLog('menuDetails:', menuDetails);
    let prm = JSON.stringify(menuDetails[0]);
    let prmid = JSON.stringify(menuDetails[1]);

    this.router.navigate([RoutePath.createModule], { queryParams: { inputMode: KEYS.actionType.edit, menuDetails: prm, moduleorder: prmid } });

  }

  AddSubMenu(parent_menu_id: any) {
    this.router.navigate(['/dashboard/menu/createmenu'], { queryParams: { inputMode: KEYS.actionType.add, parent_menu_id: parent_menu_id, menu_type: KEYS.actionType.edit } });
  }

  menuBack() {
    if (this.menuParentId != 0) {
      this.previousParentId = this.menuListdata.filter((x: any) => x.gstibo_menu_id == this.menuParentId)[0].gstibo_parent_menu_id;
      this.menuParentId = this.previousParentId;
      this.menuChildListdata = this.menuListdata.filter((x: any) => x.gstibo_parent_menu_id == this.previousParentId);
    }
    if (this.previousParentId == 0) {
      this.initColumnHeader(Labels.menu.title, true, this.labelButton.create_new_menu, false, '', '', '');
    }
  }

  deleteMenu(menu_id: any) {
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
      this.bsModalRef = this.modalService.show(ConfirmModalComponent, {
      animated: true, class: KEYS.confirmModal
    });
    this.bsModalRef.content.data = {
      title: this.labelMessages.delete_confirm_msg.title,
      message: this.labelMessages.delete_confirm_msg.message,
      btnConfirm: 'Yes',
      btnCancel: 'Cancel',
      btnConfirmStyle: 'btn-red',
      btnCancelStyle: 'btn-green'
    }
    this.bsModalRef.content.buttonevent.subscribe((res: any) => {
      if (res) {
        this.commonService.deleteMenu(dbFullPath, menu_id, this.commonService.getUserCredentials(KEYS.credential_customer_id)).subscribe((data: any) => {
          this.LoadMenu();
          //this.toastr.success(this.labelMessages.delete_success_msg.message);
          this.commonService.showModalValidate(this.labelMessages.delete_success_msg.message,'',this.messageLabel.static_messages.info,this.labelMessages.delete_success_msg.message);
        });
      }
    });
  }
  loadStatcmenus() {
    this.commonService.loadStaticMenuForUser(this.commonService.getUserCredentials(KEYS.credential_customer_id)).subscribe((data: any) => {
      if (data['table']) {
        const datas = data['table'];
        this.menuListdata.push(data['table'].filter((x: any) => x.gstibo_is_show_parentmodule_Id == 0));
        const parentmenus = data['table'].filter((x: any) => x.gstibo_is_show_parentmodule_Id == this.menuParentId);
        parentmenus.forEach((element: any) => {
          this.menuChildListdata.push(
            {
              'gstibo_menu_name': element.gstibo_menu_name,
              'moduleid': element.gstibo_menu_id,
              'gstibo_menu_id': element.gstibo_menu_id,
              'moduleorderId': element.gstibo_listing_order,
              'child': datas.filter((x: any) => (x.gstibo_parent_menu_id == element.gstibo_menu_id ||
                x.parent == element.gstibo_menu_id) && x.gstibo_menu_type == 1 && x.parent_menu_id == 0),
              'gstibo_menu_icon': 'timesheet', //element.gstibo_menu_icon,
              'pgid': element.gstibo_page_id,
              'pagetype': 'S',
              'moduleorder': (element.gstibo_menu_name == 'Settings' ? 20 : element.moduleorder),
              'gstibo_is_hide': element.gstibo_is_hide
            }
          );
        });
        this.commonService.ogLog('st0', this.menuListdata);
        this.commonService.ogLog('stc', this.menuChildListdata, this.menumoduleorderData);
        this.menuChildListdata = this.menuChildListdata.sort((a: any, b: any) => (a.moduleorder - b.moduleorder));
        this.commonService.ogLog('stc2', this.menuChildListdata);

      }
    });
  }
  loadOrderMenuData(menuid: any) {
    this.commonService.getModulemenuorderlist(menuid).subscribe((data: any) => {
      if (isData(data)) {
        // if(this.menumoduleorderData.length ==0)
        // {
        this.menumoduleorderData = data['table'];
        // }
      }
    });
  }
}
